import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { CostComponent } from '@core/components/cost/cost.component';
import {
  AffiliatesTier,
  AffiliatesTierCard,
} from '../interfaces/affiliates-tiers.interface';
import { AffiliatesTiers } from '../types/affiliates-tiers.type';

@Component({
  selector: 'app-affiliates-tier-card',
  imports: [SvgIconComponent, CostComponent],
  templateUrl: './affiliates-tier-card.component.html',
  styleUrl: './affiliates-tier-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    '[style.--affiliates-card-color]': 'color()',
    '[style.--affiliates-card-text-color]': 'tierColor()',
    '[style.--affiliates-card-bg-color]': 'bgColor()',
    '[class.active]': 'isActive()',
  },
})
export class AffiliatesTierCardComponent {
  color = input<string>('var(--green)');
  isActive = input<boolean>(false);
  tier = input.required<AffiliatesTier>();
  tierCard = input<AffiliatesTierCard>();

  tierColor = computed(() => {
    return `var(--affiliates-tier-${this.tier().fe_tier}-typography)`;
  });

  bgColor = computed(() => {
    return `var(--affiliates-tier-${this.tier().fe_tier}-typography-10)`;
  });
}
